import React from 'react';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage.tsx';
import SvgError from '@components/ringil3/COInlineMessage/icons/CoInlineMessageError.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { RouteOrderIssue } from '@app/pages/expedition/create/routeRules.ts';
import { describeRouteIssue } from '@app/pages/expedition/create/components/RouteIssuesMessage.tsx';

interface ComponentProps {
  issues: RouteOrderIssue[];
  /** The control that resolves it — the same move menu offered elsewhere, labelled "Move". */
  action?: JSX.Element;
  dataTestId?: string;
}

/**
 * Says, on the order itself, why it cannot be shipped as placed, with the means to fix it alongside.
 *
 * Sits next to the order or its unloading row rather than behind a hover, so the reason is readable
 * at a glance.
 */
const OrderIssueMessage: React.FC<ComponentProps> = ({ issues, action, dataTestId }) => {
  const { tr } = useTranslationLgs();

  if (issues.length === 0) return null;

  return (
    <COInlineMessage variant={'error'} icon={<SvgError />} buttons={action} buttonsRight dataTestId={dataTestId}>
      <div className={'flex flex-col gap-1 tracking-[0.24px] text-content-primary'}>
        {issues.map(issue => (
          <span key={issue.type}>{describeRouteIssue(issue, tr)}</span>
        ))}
      </div>
    </COInlineMessage>
  );
};

export default OrderIssueMessage;